export default {
  path: "/analysis",
  redirect: "/analysis/overview",
  meta: {
    icon: "ri:pie-chart-2-fill",
    showLink: true,
    title: "数据分析",
    rank: 40
  },
  children: [
    {
      path: "/analysis/overview",
      name: "Overview",
      component: () => import("@/views/analysis/overview/index.vue"),
      meta: {
        icon: "mdi:chart-areaspline",
        title: "数据总览"
      }
    },
    {
      path: "/analysis/useDetail",
      name: "UseDetail",
      component: () => import("@/views/analysis/overview/useDetail.vue"),
      meta: {
        icon: "mdi:chart-line",
        title: "访问量详情"
      }
    },
    {
      path: "/analysis/faultdata",
      name: "Faultdata",
      component: () => import("@/views/analysis/faultdata/index.vue"),
      meta: {
        icon: "ri:alert-fill",
        title: "软件异常数据"
      }
    },
    {
      path: "/analysis/faultdetail",
      name: "Faultdetail",
      component: () => import("@/views/analysis/faultdata/faultDetail.vue"),
      meta: {
        icon: "ri:article-line",
        title: "软件异常详情"
      }
    }
  ]
} satisfies RouteConfigsTable;
